/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql } from '@apollo/client';
import {
  renderDefaultError,
  renderDefaultLoading,
  SmartComponentProps
} from '@exo/frontend-common-utils';
import { useNewsArticleDetail } from '../../hooks/useNewsArticleDetail';
import { NewsArticle } from '../../types';

export const GetNewsArticleDetail = ({
  render,
  renderLoading = renderDefaultLoading,
  renderError = renderDefaultError,
  slug
}: Props) => {
  const { loading, data, error } = useNewsArticleDetail<NewsArticle>(
    { slug },
    GetNewsArticleDetail.fragment
  );

  if (loading || !data) return renderLoading();
  if (error) return renderError(error);

  return render({ data });
};

GetNewsArticleDetail.fragment = gql`
  fragment GetNewsArticleDetailFragment on NewsArticle {
    title {
      json
    }
    body {
      json
      links {
        entries {
          block {
            sys {
              id
            }
          }
        }
        assets {
          block {
            sys {
              id
            }
            url
          }
        }
      }
    }
    category {
      name
      color
      textColor
    }
    image {
      url
      description
    }
    publishedDate
    author {
      authorImage {
        url
        description
      }
      authorName
      role {
        json
      }
    }
  }
`;

// Define a type for the props that the render function will receive.
export type ContainerRenderProps = {
  data: NewsArticle;
};

type Props = SmartComponentProps<{
  slug: string;
  render: (props: ContainerRenderProps) => JSX.Element;
}>;
